import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faDove,
  faHome,
  faSignOutAlt,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../context/AuthContext";
import { useShoppingContext } from "../../context/ShoppingContext";
import "./Sidebar.css"; // Import the CSS for the sidebar

const Sidebar = () => {
  const { handleLogout } = useAuth();
  const { isDarkMode, showSidebar, setShowSidebar } =
    useShoppingContext();
  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowSidebar(false);
      }
    };

    if (showSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSidebar, setShowSidebar]);

  const handleLinkClick = () => {
    setShowSidebar(false);
  };

  return (
    <aside className={isDarkMode ? `sidebar ${showSidebar ? "show" : ""}` : `sidebar light ${showSidebar ? "show" : ""}`} ref={sidebarRef}>
      <ul className="sidebar-list">
        <li className="sidebar-item">
          <Link
            to="/mis-granjas"
            className={isDarkMode ? "sidebar-link" : "sidebar-link light"}
            onClick={handleLinkClick}
          >
            <FontAwesomeIcon icon={faHome} /> Mis Granjas
          </Link>
        </li>
        <li className="sidebar-item">
          <Link
            to="/mis-alimentos"
            className={isDarkMode ? "sidebar-link" : "sidebar-link light"}
            onClick={handleLinkClick}
          >
            Mis Alimentos
          </Link>
        </li>

        <li className="sidebar-item">
          <Link
            to="/mis-aves"
            className={isDarkMode ? "sidebar-link" : "sidebar-link light"}
            onClick={handleLinkClick}
          >
            <FontAwesomeIcon icon={faDove} /> Mis Aves
          </Link>
        </li>

        <li className="sidebar-item">
          <Link
            to="/mis-galpones"
            className={isDarkMode ? "sidebar-link" : "sidebar-link light"}
            onClick={handleLinkClick}
          >
            <FontAwesomeIcon icon={faWarehouse} /> Mis Galpones
          </Link>
        </li>
        <li className="sidebar-item">
          <Link
            to="/configuracion"
            className={isDarkMode ? "sidebar-link" : "sidebar-link light"}
            onClick={handleLinkClick}
          >
            <FontAwesomeIcon icon={faCog} /> Configuracion
          </Link>
        </li>
        <li className="sidebar-item">
          <button
            onClick={() => {
              handleLogout();
              setShowSidebar(false);
            }}
            className={isDarkMode ? "btn sidebar-link" : "btn sidebar-link light"}
          >
            <FontAwesomeIcon icon={faSignOutAlt} /> Cerrar Sesión
          </button>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
